var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: {
            value: _vm.dialogSwitch,
            "v-model": _vm.dialogSwitch,
            "max-width": "450px"
          },
          on: { "click:outside": _vm.closeDialog }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "d-flex flex-column",
                      attrs: { dense: "", align: "center", justify: "center" }
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mt-5", attrs: { size: "60" } },
                        [_vm._v("mdi-cloud-upload")]
                      ),
                      _c("p", [
                        _vm._v(
                          "\n            Selecciona tu archivo o arrastra aquí\n          "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-card-actions")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }